module.exports = __webpack_public_path__ + "static/androidBannerUpdatePreview-6689a06296d8f0d58402b8387bc1b82c.png";